(function(){
  function pills(){
    document.querySelectorAll('.pb-opt .pb-pills').forEach(function(w){
      var pdp=w.closest('[data-pb-pdp]');
      if(pdp&&pdp.querySelectorAll('.pb-opt').length>1)return; /* plusieurs options : les longueurs se filtrent déjà selon le format */
      var p=w.querySelectorAll('.pb-pill');
      if(p.length<=9||w.dataset.pbMore)return;
      w.dataset.pbMore='1';
      w.classList.add('is-collapsed');
      p.forEach(function(b,i){if(i>=9)b.classList.add('pb-pill--more');});
      var m=document.createElement('button');
      m.type='button';m.className='pb-more';
      m.textContent='Voir toutes les options ('+p.length+')';
      m.addEventListener('click',function(){w.classList.remove('is-collapsed');m.remove();});
      w.appendChild(m);
    });
  }

  /* Avis : « Voir plus » */
  function reviews(){
    document.querySelectorAll('[data-pb-reviews]').forEach(function(sec){
      if(sec.dataset.pbInit)return; sec.dataset.pbInit='1';
      var list=sec.querySelector('[data-list]'); if(!list)return;
      var cards=[].slice.call(list.querySelectorAll('.pb-msg'));
      var step=+list.dataset.step||5, more=sec.querySelector('[data-more]');
      var shown=step;
      function render(){
        cards.forEach(function(c,i){c.hidden=i>=shown;});
        if(more){
          var left=cards.length-shown;
          more.hidden=left<=0;
          more.textContent='Voir plus d’avis';
        }
      }
      if(more)more.addEventListener('click',function(){shown+=step;render();});
      render();
      var w=sec.querySelector('[data-write]');
      if(w&&/contact_posted|form_type=contact/.test(location.search+location.hash)){w.open=true;w.scrollIntoView({block:'center'});}
    });
  }

  /* Livraison : 3 étapes, avec le délai propre au produit (Virgin / Raw) */
  function esc(t){var d=document.createElement('div');d.textContent=t||'';return d.innerHTML;}
  function eta(){
    document.querySelectorAll('[data-eta]').forEach(function(el){
      var p=el.closest('.pb-ship'); if(!p||p.dataset.pbEta)return; p.dataset.pbEta='1';
      var min=el.dataset.min||9, max=el.dataset.max||15;
      var st=el.dataset.stepT||'Préparation', sd=el.dataset.stepD||'À la main, avec soin';
      var d=document.createElement('div'); d.className='pb-eta';
      d.innerHTML='<ol class="pb-eta__steps">'+
        '<li><b>Aujourd’hui</b><span>Tu commandes</span></li>'+
        '<li><b>'+esc(st)+'</b><span>'+esc(sd)+'</span></li>'+
        '<li><b>Chez toi</b><span>En '+esc(min)+' à '+esc(max)+' jours ouvrés</span></li>'+
        '</ol>'+(el.dataset.free?'<p class="pb-eta__free">Envoi suivi · livraison '+esc(el.dataset.free)+'</p>':'');
      p.replaceWith(d);
    });
  }

  /* Prochain envoi (Raw) : compte à rebours vers la prochaine commande fournisseur */
  function cutoff(){
    var DAYS=['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
    document.querySelectorAll('[data-cutoff]').forEach(function(el){
      if(el.dataset.pbInit)return; el.dataset.pbInit='1';
      var days=el.dataset.cutoff.split(',').map(function(x){return parseInt(x,10);}).filter(function(x){return x>=0&&x<=6;});
      var h=parseInt(el.dataset.hour,10); if(isNaN(h))h=23;
      if(!days.length)return;
      var txt=el.querySelector('[data-cut-text]'), left=el.querySelector('[data-cut-left]');
      function next(now){
        for(var i=0;i<8;i++){
          var d=new Date(now); d.setDate(d.getDate()+i); d.setHours(h,59,59,0);
          if(days.indexOf(d.getDay())>-1&&d>now)return d;
        }
      }
      function tick(){
        var now=new Date(), t=next(now); if(!t)return;
        var diff=t-now, dd=Math.floor(diff/864e5), hh=Math.floor(diff%864e5/36e5), mm=Math.floor(diff%36e5/6e4);
        var today=new Date(now); today.setHours(0,0,0,0);
        var tday=new Date(t); tday.setHours(0,0,0,0);
        var gap=Math.round((tday-today)/864e5);
        var when=gap===0?'ce soir':(gap===1?'demain soir':DAYS[t.getDay()]+' soir');
        txt.textContent='Commande avant '+when+' ('+h+'h59) pour partir dans le prochain envoi';
        left.textContent=dd>0?('Il reste '+dd+' j '+hh+' h'):('Il reste '+hh+' h '+(mm<10?'0':'')+mm+' min');
        el.hidden=false;
      }
      tick(); setInterval(tick,30000);
    });
  }

  /* FAQ produit tout en bas, après les avis */
  function faq(){
    var acc=document.querySelector('[data-pb-faq]'), avis=document.getElementById('avis');
    if(!acc||!avis||acc.dataset.pbMoved)return; acc.dataset.pbMoved='1';
    var host=avis.closest('.shopify-section')||avis;
    var s=document.createElement('section'); s.className='pb pb-faqx';
    s.innerHTML='<div class="pb-wrap pb-pad"><div class="pb-head pb-head--center"><h2 class="pb-h2">Tes questions</h2></div></div>';
    s.querySelector('.pb-wrap').appendChild(acc);
    host.parentNode.insertBefore(s,host.nextSibling);
  }

  function run(){pills();reviews();eta();cutoff();faq();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();
